const NS = 'ManagerActionsService';

export enum ManagerActionName {
  ManagerChange = 'manager-change',
}

class ManagerActionsService {

  private $rootScope: any;

  setup($rootScope: any) {
    this.$rootScope = $rootScope;
  }

  public managerChange(): void {
    this.$rootScope.$broadcast(ManagerActionName.ManagerChange);
  }
}

// singleton
const instance = new ManagerActionsService();
export default instance;
